import { render, staticRenderFns } from "./RiskSpread.vue?vue&type=template&id=0e34885e&scoped=true&"
import script from "./RiskSpread.vue?vue&type=script&lang=js&"
export * from "./RiskSpread.vue?vue&type=script&lang=js&"
import style0 from "./RiskSpread.vue?vue&type=style&index=0&id=0e34885e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e34885e",
  null
  
)

export default component.exports